export const TENANT_PORTAL_PATHS = {
  DEFAULT: ":regionId/tenant/:propertyId",
  OVERVIEW: "",
  MAINTENANCE: "maintenance",
  REQUEST_MAINTENANCE: "maintenance/request",
  INSPECTIONS: "inspections",
  PAYMENTS: "payments",
  HANDBOOK: "handbook",
} as const;
